export default {
	namespaced: true,
	state: {
		visible: false,
		header: '',
		showBack: false,
		form: 'addRoute'
		
	},

	actions:{
		toggleVisibility(context, payload)
		{
			context.commit('toggleVisibility', payload);
		},
		setHeader(context, payload)
		{
			context.commit('setHeader', payload);
		},

		setForm(context, payload)
		{
			//console.log("setForm", payload)
			context.commit('setForm', payload)
		},

		setFormAddRoute(context)
		{
			context.commit('routes/flushSelectedNewRouteRouteGroup', {}, {root: true})
			context.commit('setForm', 'addRoute')
		}

		
	},

	

	mutations: {
		toggleVisibility(state, payload)
		{
			state.visible = payload;
		},

		setForm(state, payload)
		{
			state.form = payload
		},

		

		setHeader(state, payload)
		{
			
			state.header = payload;
		}
	},

	getters: {
		visibility(state){
			return state.visible;
		},

		header(state)
		{
			
			return state.header;
		},

		showBack(state)
		{
			return state.showBack;
		},

		formAddRoute(state)
		{
			return state.form === 'addRoute';
		},

		formEditRoute(state)
		{
			return state.form === 'editRoute';
		},

		formAddLocationToRoute(state)
		{
			return state.form === 'addLocationToRoute';
		},

		route(state)
		{
			return state.route;
		}
	}
}